// AUTO-GENERATED from '2. Habitations_socio-economic .xlsx'
const ST_HABITATION_SEA = {
  "state": {
    "habitations": 9806,
    "households": 487680,
    "members": 1674562,
    "male": 840554,
    "female": 833616,
    "third_gender": 392
  },
  "districts": {
    "ARIYALUR": {
      "habitations": 159,
      "households": 3331,
      "members": 11894,
      "male": 5926,
      "female": 5967,
      "third_gender": 1
    },
    "CHENGALPATTU": {
      "habitations": 521,
      "households": 8306,
      "members": 27295,
      "male": 13567,
      "female": 13710,
      "third_gender": 18
    },
    "CHENNAI": {
      "habitations": 20,
      "households": 546,
      "members": 1809,
      "male": 884,
      "female": 925,
      "third_gender": 0
    },
    "COIMBATORE": {
      "habitations": 334,
      "households": 8400,
      "members": 25737,
      "male": 12631,
      "female": 13101,
      "third_gender": 5
    },
    "CUDDALORE": {
      "habitations": 394,
      "households": 4596,
      "members": 16133,
      "male": 7973,
      "female": 8156,
      "third_gender": 4
    },
    "DHARMAPURI": {
      "habitations": 535,
      "households": 19820,
      "members": 69435,
      "male": 35392,
      "female": 34013,
      "third_gender": 30
    },
    "DINDIGUL": {
      "habitations": 90,
      "households": 2836,
      "members": 9540,
      "male": 4792,
      "female": 4747,
      "third_gender": 1
    },
    "ERODE": {
      "habitations": 239,
      "households": 5727,
      "members": 18418,
      "male": 9129,
      "female": 9288,
      "third_gender": 1
    },
    "KALLAKURICHI": {
      "habitations": 326,
      "households": 15248,
      "members": 58450,
      "male": 29741,
      "female": 28707,
      "third_gender": 2
    },
    "KANCHEEPURAM": {
      "habitations": 353,
      "households": 5369,
      "members": 17946,
      "male": 8886,
      "female": 9053,
      "third_gender": 7
    },
    "KANNIYAKUMARI": {
      "habitations": 151,
      "households": 2146,
      "members": 7052,
      "male": 3472,
      "female": 3579,
      "third_gender": 1
    },
    "KARUR": {
      "habitations": 30,
      "households": 373,
      "members": 1316,
      "male": 638,
      "female": 677,
      "third_gender": 1
    },
    "KRISHNAGIRI": {
      "habitations": 362,
      "households": 6162,
      "members": 22914,
      "male": 11617,
      "female": 11285,
      "third_gender": 12
    },
    "MADURAI": {
      "habitations": 66,
      "households": 2963,
      "members": 10565,
      "male": 5248,
      "female": 5317,
      "third_gender": 0
    },
    "MAYILADUTHURAI": {
      "habitations": 71,
      "households": 729,
      "members": 2654,
      "male": 1311,
      "female": 1343,
      "third_gender": 0
    },
    "NAGAPATTINAM": {
      "habitations": 45,
      "households": 520,
      "members": 1867,
      "male": 907,
      "female": 960,
      "third_gender": 0
    },
    "NAMAKKAL": {
      "habitations": 502,
      "households": 18259,
      "members": 60087,
      "male": 30780,
      "female": 29303,
      "third_gender": 4
    },
    "PERAMBALUR": {
      "habitations": 57,
      "households": 1460,
      "members": 4933,
      "male": 2479,
      "female": 2452,
      "third_gender": 2
    },
    "PUDUKKOTTAI": {
      "habitations": 56,
      "households": 968,
      "members": 3358,
      "male": 1661,
      "female": 1697,
      "third_gender": 0
    },
    "RAMANATHAPURAM": {
      "habitations": 22,
      "households": 906,
      "members": 3431,
      "male": 1712,
      "female": 1719,
      "third_gender": 0
    },
    "RANIPET": {
      "habitations": 259,
      "households": 3172,
      "members": 10679,
      "male": 5305,
      "female": 5372,
      "third_gender": 2
    },
    "SALEM": {
      "habitations": 607,
      "households": 33801,
      "members": 112916,
      "male": 57137,
      "female": 55769,
      "third_gender": 10
    },
    "SIVAGANGAI": {
      "habitations": 67,
      "households": 1159,
      "members": 3924,
      "male": 1931,
      "female": 1993,
      "third_gender": 0
    },
    "TENKASI": {
      "habitations": 91,
      "households": 1571,
      "members": 5399,
      "male": 2628,
      "female": 2770,
      "third_gender": 1
    },
    "THANJAVUR": {
      "habitations": 147,
      "households": 1595,
      "members": 5995,
      "male": 2998,
      "female": 2996,
      "third_gender": 1
    },
    "THE NILGIRIS": {
      "habitations": 422,
      "households": 9237,
      "members": 29641,
      "male": 14092,
      "female": 15548,
      "third_gender": 1
    },
    "THENI": {
      "habitations": 39,
      "households": 799,
      "members": 2619,
      "male": 1309,
      "female": 1308,
      "third_gender": 2
    },
    "THOOTHUKKUDI": {
      "habitations": 137,
      "households": 1355,
      "members": 4954,
      "male": 2439,
      "female": 2515,
      "third_gender": 0
    },
    "TIRUCHIRAPPALLI": {
      "habitations": 146,
      "households": 5296,
      "members": 18808,
      "male": 9607,
      "female": 9199,
      "third_gender": 2
    },
    "TIRUNELVELI": {
      "habitations": 141,
      "households": 1704,
      "members": 6007,
      "male": 2969,
      "female": 3037,
      "third_gender": 1
    },
    "TIRUPATHUR": {
      "habitations": 427,
      "households": 15065,
      "members": 58578,
      "male": 29938,
      "female": 28631,
      "third_gender": 9
    },
    "TIRUPPUR": {
      "habitations": 221,
      "households": 1877,
      "members": 6410,
      "male": 3116,
      "female": 3292,
      "third_gender": 2
    },
    "TIRUVALLUR": {
      "habitations": 701,
      "households": 13640,
      "members": 43802,
      "male": 21639,
      "female": 22145,
      "third_gender": 18
    },
    "TIRUVANNAMALAI": {
      "habitations": 1043,
      "households": 27418,
      "members": 93613,
      "male": 47163,
      "female": 46418,
      "third_gender": 32
    },
    "TIRUVARUR": {
      "habitations": 102,
      "households": 1382,
      "members": 4900,
      "male": 2423,
      "female": 2477,
      "third_gender": 0
    },
    "TOTAL": {
      "habitations": 1,
      "households": 243840,
      "members": 837281,
      "male": 420277,
      "female": 416808,
      "third_gender": 196
    },
    "VELLORE": {
      "habitations": 318,
      "households": 7021,
      "members": 24584,
      "male": 12189,
      "female": 12380,
      "third_gender": 15
    },
    "VILLUPURAM": {
      "habitations": 604,
      "households": 9083,
      "members": 29618,
      "male": 14648,
      "female": 14959,
      "third_gender": 11
    }
  }
};

export default ST_HABITATION_SEA;
